import type { TablePaginationConfig } from 'antd'

export const DEVICES_PER_PAGE = 10

export const DEVICES_SETTINGS_PAGE_WITH_HASH =
  '/settings/home-settings#access-control'

export interface TableParams {
  pagination?: TablePaginationConfig
  order?: string
  field?: string
}
